export default "__VITE_ASSET__8973b8e5__"